import { router } from "expo-router";
import React, { useEffect, useState } from "react";
// @ts-ignore - image import
import defaultProfileImg from "@/assets/images/default-profile.webp";

type Props = {
  photoURL?: string | null;
  alt: string;
  style: any;
  userId?: string | null;
};

export const AvatarImage = ({ photoURL, alt, style, userId }: Props) => {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [photoURL]);

  const src = !photoURL || errored ? defaultProfileImg.uri : photoURL;

  const img = (
    <img
      src={src}
      style={{ backgroundColor: "#e5e7eb", ...style }}
      alt={alt}
      width={40}
      height={40}
      loading="lazy"
      decoding="async"
      onError={() => setErrored(true)}
    />
  );

  if (!userId) return img;

  return (
    <button
      type="button"
      aria-label={alt}
      onClick={(e) => {
        e.stopPropagation();
        router.push({
          pathname: "/(tabs)/public-profile",
          params: { userId },
        });
      }}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0,
        flexShrink: 0,
      }}
    >
      {img}
    </button>
  );
};
